module.exports = __webpack_public_path__ + "img/home_header_md.41cd977d.png";